import React, { createContext, useState } from 'react';

// Create a context for clinic details
export const ClinicContext = createContext();

// Create a provider component
export const ClinicProvider = ({ children }) => {
  const [clinicId, setClinicId] = useState(null); // State to store clinic ID
  const [clinicName, setClinicName] = useState(''); // State to store clinic name

  return (
    <ClinicContext.Provider value={{ clinicId, setClinicId, clinicName, setClinicName }}>
      {children}
    </ClinicContext.Provider>
  );
};
